import { __assign, __extends, __rest } from "tslib";
import * as React from 'react';
import s from './search-input.scss';
import { throttle, debounce } from 'throttle-debounce';
import { Search, Loader, Box } from 'wix-style-react';
import { composer } from '../../../component-decorators/composer';
export var SearchInput = composer()
    .withTranslation()
    .compose(function (_a) {
    var t = _a.t, props = __rest(_a, ["t"]);
    return (React.createElement(SearchInputComponent, __assign({ t: t }, props)));
});
var SearchInputComponent = /** @class */ (function (_super) {
    __extends(SearchInputComponent, _super);
    function SearchInputComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChange = function (event) {
            _this.setState({ query: event.target.value }, function () {
                var query = _this.state.query;
                if (query.length < 5) {
                    _this.autocompleteSearchThrottled(query);
                }
                else {
                    _this.autocompleteSearchDebounced(query);
                }
            });
        };
        _this.handleKeyDown = function (event) {
            if (event.key === 'Enter' && _this.state.query) {
                // tslint:disable-next-line: no-floating-promises
                _this.props.onSearchInputEnter(_this.state.query);
            }
        };
        _this.autocompleteSearchDebounced = debounce(300, _this.props.onSearchValueChange);
        _this.autocompleteSearchThrottled = throttle(300, _this.props.onSearchValueChange);
        _this.state = {
            query: '',
        };
        return _this;
    }
    SearchInputComponent.prototype.render = function () {
        var _this = this;
        var _a = this.props, isLoading = _a.isLoading, isInMenu = _a.isInMenu, isExpandable = _a.isExpandable, isInHeader = _a.isInHeader;
        return (React.createElement("div", { "data-testid": "search-input", className: s.searchInput + "\n        " + (isInHeader ? s.isInHeader : '') + "\n        " + (isInMenu ? s.isInMenu : '') + "\n        " + (isExpandable ? s.isExpandable : ''), onKeyDown: this.handleKeyDown }, isExpandable ? (React.createElement(Box, { align: "right", verticalAlign: "middle" },
            React.createElement(Search, { itemHeight: 'big', dataHook: 'search-input-expandable', onChange: function (e) { return _this.handleChange(e); }, placeholder: this.props.t('search.box.place.holder'), size: 'medium', expandable: isExpandable, suffix: isLoading ? (React.createElement("div", { className: s.iconsWrapper },
                    React.createElement("div", { className: s.loaderWrapper },
                        React.createElement(Loader, { size: 'tiny' })),
                    ' ')) : null }))) : (React.createElement(Search, { itemHeight: 'big', dataHook: 'search-input', onChange: function (e) { return _this.handleChange(e); }, placeholder: this.props.t('search.box.place.holder'), size: isInMenu || isInHeader ? 'small' : 'large', suffix: isLoading ? (React.createElement("div", { className: s.iconsWrapper },
                React.createElement("div", { className: s.loaderWrapper },
                    React.createElement(Loader, { size: 'tiny' })),
                ' ')) : null }))));
    };
    return SearchInputComponent;
}(React.Component));
export { SearchInputComponent };
//# sourceMappingURL=search-input.js.map